import { useCustomMutation } from '@mutations/index';
import { QueryKeys } from '@queries/index';
import Config from '../../config';
import { METHODS } from '../constants';

export const useAddTlsAccount = () =>
  useCustomMutation({
    handleData: (data: any) => ({
      url: Config.endpoints.ADD_TLS_ACCOUNT.replace(/:periodName/, data.periodName),
      method: METHODS.POST,
      body: data,
    }),
    invalidateKey: query => [QueryKeys.tlsAccounts.TlsAccountsList].includes(query.queryKey[0] as string),
    successMessage: 'TLS account added successfully',
    errorMessage: 'TLS account adding failed',
  });

export const useUpdateTlsAccount = () =>
  useCustomMutation({
    handleData: (data: any) => ({
      url: Config.endpoints.UPDATE_TLS_ACCOUNT
        .replace(/:periodName/, data.periodName)
        .replace(/:account/, data.account),
      method: METHODS.PUT,
      body: data,
    }),
    invalidateKey: query => [QueryKeys.tlsAccounts.TlsAccountsList].includes(query.queryKey[0] as string),
    successMessage: 'TLS account updated successfully',
    errorMessage: 'TLS account updating failed',
  });

export const useDeleteTlsAccount = (onSuccess?: () => void) =>
  useCustomMutation({
    handleData: (data: any) => ({
      url: Config.endpoints.DELETE_TLS_ACCOUNT
        .replace(/:periodName/, data.periodName)
        .replace(/:account/, data.account),
      method: METHODS.DELETE,
    }),
    invalidateKey: query => [QueryKeys.tlsAccounts.TlsAccountsList].includes(query.queryKey[0] as string),
    successMessage: 'TLS account removed successfully',
    errorMessage: 'TLS account removing failed',
    onSuccess,
  });
